// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__341U7","terms__heading":"Terms_terms__heading__2b0B6","terms__subheading":"Terms_terms__subheading__3SWVm"};